"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.encode = void 0;
var helper_1 = require("./helper");
/**
 *
 * @param libraryIds an array of library IDs - these are of the format LX-YYY
 * @param domain i.e 'death'
 * @param formatCode The mode of play. Constructed is 1.
 */
function encode(libraryIds, domain, formatCode) {
    if (formatCode === void 0) { formatCode = 1; }
    var encodedLibraryIds = "";
    libraryIds.forEach(function (libraryId) {
        encodedLibraryIds += helper_1.encodeLibraryId(libraryId);
    });
    var domainCode = helper_1.encodeDomain(domain);
    var deckCode = helper_1.headerCode + "_" + formatCode + "_" + domainCode + "_" + encodedLibraryIds;
    return deckCode;
}
exports.encode = encode;
